import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const MembershipTab = () => {
  const benefits = [
    "Unlimited access for all services",
    "Advanced Reporting & Analytics",
    "Priority Customer Support",
    "Offline Mode (Auto Sync)",
    "Data Security & Backup",
  ];

  return (
    <div className={styles.membershipCard}>
      <div className={styles.topGradientBar}></div>
      <div className={styles.planInfoSection}>
        <div className={styles.planTitle}>
         Premium Monthly Plan
        </div>
        <div className={styles.planAmount}>
         LKR 1,500.00
        </div>
      </div>
      <div className={styles.planBenefits}>
        {benefits.map((benefit, index) => (
          <div key={index} className={styles.benefitItem}>
            <CheckCircleIcon className={styles.benefitIcon} />
            <span className={styles.benefitText}>{benefit}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MembershipTab